// Header.js
import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/icons/small_icons/logo_header.svg'
import menu from '../assets/icons/small_icons/menu_header.svg'
import home from '../assets/icons/small_icons/home_header.png'
import notifications from '../assets/icons/small_icons/notifications_header.svg'
import profile from '../assets/icons/small_icons/profile_header.svg'

const HeaderInvite = () => {
  return (
    <header>

      <div className='row m-0 p-0' style={{height: "5vh", backgroundColor: "#01153a00", borderStyle: "none", borderColor: "#01153a"}}>
        
      </div>
    </header>
  );
};

export default HeaderInvite;
